import { storage } from 'lib';
import { ICurrentDateRange } from 'store/types';

const CURRENT_DATE_RANGE_KEY = process.env.REACT_APP_CURRENT_DATE_RANGE || 'current_date_range';

const CurrentDateRangeService = {
  set: (currentDateRange: ICurrentDateRange): ICurrentDateRange => {
    storage.setItem(CURRENT_DATE_RANGE_KEY, JSON.stringify(currentDateRange));
    return currentDateRange;
  },
  get: (): ICurrentDateRange | undefined => {
    const currentDateRange = storage.getItem(CURRENT_DATE_RANGE_KEY);
    if (currentDateRange === null) return undefined;
    return JSON.parse(currentDateRange) as ICurrentDateRange;
  },
  clear: (): boolean => {
    storage.removeItem(CURRENT_DATE_RANGE_KEY);
    return true;
  },
};

export default CurrentDateRangeService;
